import type { Icon as IconType } from '@rover/icons';
import AlertCaution from '@rover/icons/svg/alert-caution.svg';
import AlertInfo from '@rover/icons/svg/alert-info.svg';
import AlertSuccess from '@rover/icons/svg/alert-success.svg';
import TrustLogo from '@rover/icons/svg/trust-logo.svg';
import type { RoverTheme } from '@rover/types/src/RoverTheme';

import { AlertSeverity } from './AlertSeverity';

export { AlertSeverity };

const ALERT_SEVERITY_ICONS: Record<AlertSeverity, React.ComponentType<IconType>> = {
  [AlertSeverity.DANGER]: AlertCaution,
  [AlertSeverity.CAUTION]: AlertCaution,
  [AlertSeverity.WARNING]: AlertInfo,
  [AlertSeverity.SUCCESS]: AlertSuccess,
  [AlertSeverity.INFO]: AlertInfo,
  [AlertSeverity.SYSTEM]: TrustLogo,
};

export const getBackgroundColorForSeverity = (
  severity: AlertSeverity,
  { background }: RoverTheme
): string => {
  const severityColors: Record<AlertSeverity, string> = {
    [AlertSeverity.DANGER]: background.error.toString(),
    [AlertSeverity.WARNING]: background.caution.toString(),
    [AlertSeverity.CAUTION]: background.secondary.toString(),
    [AlertSeverity.SUCCESS]: background.success.toString(),
    [AlertSeverity.INFO]: background.highlight.toString(),
    [AlertSeverity.SYSTEM]: background.info.toString(), // Updated to use 'info' instead of 'accent_secondary'
  };

  return severityColors[severity] || severityColors[AlertSeverity.INFO];
};

export const getBorderColorForSeverity = (
  severity: AlertSeverity,
  { colors: { border, interactive_border: interactiveBorder } }: RoverTheme
): string => {
  const severityBorders: Record<AlertSeverity, string> = {
    [AlertSeverity.DANGER]: border.error.toString(),
    [AlertSeverity.WARNING]: border.caution.toString(),
    [AlertSeverity.CAUTION]: interactiveBorder.primary_active.toString(), // Adjusted mapping
    [AlertSeverity.SUCCESS]: border.success.toString(),
    [AlertSeverity.INFO]: border.highlight.toString(),
    [AlertSeverity.SYSTEM]: border.input_focus.toString(), // Adjusted mapping
  };

  return severityBorders[severity] || severityBorders[AlertSeverity.INFO];
};

export const getIconForSeverity = (severity: AlertSeverity): React.ComponentType<IconType> => {
  return ALERT_SEVERITY_ICONS[severity] || ALERT_SEVERITY_ICONS[AlertSeverity.INFO];
};
